import { cx } from '@emotion/css';
import PlayListRouteStyle from './PlayListRoute.module.scss';
import { useRef } from 'react';
import { useRouter } from 'next/router';
import React from 'react';

import gsap from 'gsap';
import MotionPathPlugin from 'gsap/dist/MotionPathPlugin';

gsap.registerPlugin(MotionPathPlugin);

const PlayListRoute = React.forwardRef((props, ref) => {
  const router = useRouter();
  const buttonWrapperRef = useRef(null);
  const pathRef = useRef(null);
  const { className, setFocusButton } = props;

  const clickRouteButton = () => {
    const buttonWrapperElement = buttonWrapperRef.current;
    const pathElement = pathRef.current;
    setFocusButton(true);

    const timeline = gsap.timeline({
      onComplete: () => router.push('/flow/main'),
    });

    const rawPath = MotionPathPlugin.getRawPath(pathElement);
    MotionPathPlugin.cacheRawPathMeasurements(rawPath);
    const delta = MotionPathPlugin.getRelativePosition(buttonWrapperElement, pathElement, [0.5, 0.5], [0, 1]);

    const pathID = 'button-route';
    const path = document.getElementById(pathID);
    if (!path) return;

    timeline.to(buttonWrapperElement, {
      duration: 1,
      ease: 'power1.inOut',
      x: '+=' + delta.x,
      y: '+=' + delta.y,
    });
    timeline.to(buttonWrapperElement, {
      duration: 3,
      ease: 'power1.inOut',
      motionPath: {
        path: `#${pathID}`,
        align: `#${pathID}`,
        alignOrigin: [0.5, 0.5],
      },
    });
  };

  return (
    <div ref={ref} className={cx(className, PlayListRouteStyle.playListRouteContainer)}>
      <svg className={PlayListRouteStyle.routeImage768} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 502.104 477.1">
        <path
          data-name="빼기 88"
          d="M19.906 477.1a19.9 19.9 0 1 1 15.286-32.647h14.785a36.782 36.782 0 0 0 36.51-32.672l.071-.708c.1-1.1.15-2.22.15-3.338v-40.387a12.939 12.939 0 0 1 25.792-1.484l.087-.008v41.879A62.718 62.718 0 0 1 84.842 459.7c-.23.173-.47.341-.711.5l-1.164.741c-.235.145-.472.282-.706.408a62.247 62.247 0 0 1-32.285 8.978H34.869a19.859 19.859 0 0 1-14.963 6.773zm79.74-140.6a12.937 12.937 0 0 1-12.938-12.93v-1.094a12.938 12.938 0 0 1 25.877 0v1.094a12.937 12.937 0 0 1-12.939 12.93zm0-44.874A12.937 12.937 0 0 1 86.708 278.7v-1.1a12.938 12.938 0 0 1 25.877 0v1.1a12.937 12.937 0 0 1-12.938 12.935zm3.938-44.78a12.234 12.234 0 0 1-4.69-.926 13.151 13.151 0 0 1-7.094-6.8 12.235 12.235 0 0 1-.1-9.709l.531-1.252a12.938 12.938 0 0 1 23.715 10.35 13.538 13.538 0 0 1-12.362 8.341zm31.728-29.484a12.937 12.937 0 0 1-4.262-25.151l.982-.346a12.936 12.936 0 1 1 8.62 24.393l-1.076.377a12.868 12.868 0 0 1-4.265.731zm41.02-18.12a12.935 12.935 0 0 1-6.21-24.291l.913-.5c.257-.142.524-.277.792-.4l-.033-.064c22.4-12.5 41.286-27.731 56.144-45.274a166.552 166.552 0 0 0 22.281-33.866 164.875 164.875 0 0 0 8.327-20.147 174.7 174.7 0 0 0 5.939-22.445 64.3 64.3 0 0 1 2.515-9.2c.041-.126.085-.254.135-.391l.482-1.285a9.3 9.3 0 0 1 .163-.4 65.028 65.028 0 0 1 37.127-36.657c.193-.082.369-.152.536-.214l1.285-.463c.171-.06.329-.111.482-.158A64.936 64.936 0 0 1 328.243 0h28.321v.039a12.935 12.935 0 0 1 0 25.792v.041h-28.321a39.018 39.018 0 0 0-38.357 31.337 202.7 202.7 0 0 1-6.874 26.014 191.871 191.871 0 0 1-9.6 23.29 189.288 189.288 0 0 1-11.891 20.705 193.994 193.994 0 0 1-13.722 18.269 209.437 209.437 0 0 1-24.723 24.59c-.134.123-.275.248-.432.38l-.89.744c-.157.13-.318.257-.478.378a245.748 245.748 0 0 1-37.135 25.174c-.209.13-.408.247-.607.355l-1.012.554a12.964 12.964 0 0 1-6.19 1.585zM490.215 25.87h-1.095a12.934 12.934 0 0 1-9.149-22.081A12.855 12.855 0 0 1 489.12 0h1.094A12.933 12.933 0 0 1 502.1 7.826v10.218a12.933 12.933 0 0 1-11.885 7.826zm-44.886 0h-1.1a12.934 12.934 0 0 1-9.149-22.081A12.855 12.855 0 0 1 444.234 0h1.1a12.934 12.934 0 0 1 9.149 22.081 12.855 12.855 0 0 1-9.154 3.789zm-44.888 0h-1.094A12.934 12.934 0 0 1 390.2 3.789 12.855 12.855 0 0 1 399.348 0h1.094a12.934 12.934 0 0 1 9.149 22.081 12.855 12.855 0 0 1-9.15 3.789z"
          transform="translate(-.001)"
          fill="#4e57ff"
        />
        <g data-name="그룹 8309">
          <path
            ref={pathRef}
            id="button-route"
            data-name="패스 15442"
            d="M451 601.984h38.356a42.967 42.967 0 0 0 42.919-43.013l.929-120.507c.185-24.047-4.7-61.478 20.3-79.518 13-8.018 11-7.016 49-25.056s99.008-71.807 110-142.315a44.922 44.922 0 0 1 43.205-33.163h179.045"
            transform="translate(-433 -144.896)"
            // stroke="#4e57ff"
            strokeMiterlimit="10"
            fill="none"
          />
        </g>
      </svg>
      <div ref={buttonWrapperRef} className={PlayListRouteStyle.routeButtonWrapper}>
        <i className={PlayListRouteStyle.iconPlaylistRobot} />
        <button className={PlayListRouteStyle.routeButton} onClick={clickRouteButton}>
          <div className={PlayListRouteStyle.routeButtonBorder} />
          <div className={PlayListRouteStyle.routeButtonText}>
            나만의 <strong>관람루트</strong>
          </div>
        </button>
      </div>
    </div>
  );
});

PlayListRoute.displayName = 'PlayListRoute';

export default PlayListRoute;
